import { enforce, test } from "vest";
import { trans } from "@/service/i18n/i18n";
import { accessFormFieldValue, createFieldName } from "@/forms/form-field";

export function createFileFieldValidationSuite(
  definition: FileField,
  formValue: any,
): void {
  const value = accessFormFieldValue(definition, formValue);

  if (definition.required) {
    test(createFieldName(definition), trans("form_validation.required"), () => {
      enforce(value).isNotEmpty();
    });
  }
}
